
import React from 'react';
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle, 
  CardFooter 
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Save } from 'lucide-react';

interface PolicyCardProps {
  title: string;
  description: string;
  isEditing: boolean;
  onEditToggle: () => void;
  onSave: () => void;
  children: React.ReactNode;
}

const PolicyCard = ({ 
  title, 
  description, 
  isEditing, 
  onEditToggle, 
  onSave, 
  children 
}: PolicyCardProps) => {
  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex justify-between items-center">
          <div>
            <CardTitle>{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </div>
          <Button 
            variant={isEditing ? "default" : "outline"}
            onClick={onEditToggle}
          >
            {isEditing ? "Cancel" : "Edit Policy"}
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {children}
      </CardContent>
      {isEditing && (
        <CardFooter className="flex justify-between">
          <div className="flex items-center text-amber-500">
            <AlertTriangle className="h-4 w-4 mr-2" />
            <span className="text-sm">Changes will need CFO approval before becoming effective</span>
          </div>
          <Button onClick={onSave}>
            <Save className="h-4 w-4 mr-2" />
            Save Policy Changes
          </Button>
        </CardFooter>
      )}
    </Card>
  );
};

export default PolicyCard;
